<template>

    <v-layout>
        <v-flex>
            <v-layout mb-2>
                <div class="subtitle mb-0">Notes</div>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = true" color="secondary">
                    <v-icon>add</v-icon>
                    Ajouter
                </v-btn>
            </v-layout>

            <v-container grid-list-sm pa-0>
                <v-layout row v-if="list && list.length > 0">
                    <v-flex xs12>
                        <v-list three-line>
                            <template v-for="(remark, index) in list">
                                <v-list-tile :key="'remark-' + remark.id">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            <span>{{ remark.text }}</span>
                                        </v-list-tile-title>

                                        <v-list-tile-sub-title>
                                            créée le {{ remark.created_at | shortDate }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-flex>
                                        <v-btn flat @click="startEditRemark(remark)">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn flat @click="startDeleteRemark(remark)">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                            </v-flex>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider
                                    v-if="index + 1 < list.length"
                                    :key="'remark-divider-' + index"
                                ></v-divider>
                            </template>
                        </v-list>
                    </v-flex>
                </v-layout>
                <v-layout v-else mb-5>
                    <v-spacer></v-spacer>
                    <div>Aucune note</div>
                    <v-spacer></v-spacer>
                </v-layout>

            </v-container>

            <v-dialog max-width="480" persistent v-model="dialog">
                <v-card>
                    <v-card-title class="headline">Nouvelle note</v-card-title>
                    <v-form ref="newRemarkForm" lazy-validation>
                        <v-card-text>
                            <v-textarea
                                v-model="text"
                                :rules="notEmptyRules"
                                label="Note"
                            ></v-textarea>
                        </v-card-text>
                    </v-form>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog = false">Annuler</v-btn>
                        <v-btn @click="createNewRemark()" color="secondary" text>Enregistrer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="editDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Modifier la note</v-card-title>
                    <v-form ref="editRemarkForm" lazy-validation>
                        <v-card-text>
                            <v-textarea
                                v-model="selectedRemarkText"
                                :rules="notEmptyRules"
                                label="Note"
                            ></v-textarea>
                        </v-card-text>
                    </v-form>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="editDialog = false">Annuler</v-btn>
                        <v-btn @click="doEditRemark()" color="secondary" text>Enregistrer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="deleteDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Supprimer la note</v-card-title>
                    <v-card-text>Voulez-vous vraiment supprimer la note ?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="doDeleteRemark()">Oui, supprimer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>

</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import {getTranslationString} from "../../helper";

export default {
    name: "RemarkListView",
    computed: {
        ...mapState('remarks', {
            list: state => state.list,
            selectedRemark: state => state.selectedRemark
        }),
        selectedRemarkText: {
            get() {
                return this.$store.state.remarks.selectedRemark?.text
            },
            set(value) {
                this.setSelectedRemarkText(value)
            }
        }
    },
    data: () => ({
        dialog: false,
        editDialog: false,
        deleteDialog: false,
        text: "",
        notEmptyRules: [
            v => !!v || 'Le texte est requis'
        ],
    }),
    mounted() {
        this.getRemarks()
    },
    methods: {
        ...mapActions('remarks', [
            'getRemarks',
            'createRemark',
            'editRemark',
            'deleteRemark'
        ]),
        ...mapMutations('remarks', {
            setSelectedRemark: 'setSelectedRemark',
            setSelectedRemarkText: 'setSelectedRemarkText'
        }),
        startEditRemark(remark) {
            this.editDialog = true;
            this.setSelectedRemark(remark);
        },
        startDeleteRemark(remark) {
            this.deleteDialog = true;
            this.setSelectedRemark(remark);
        },
        doEditRemark() {
            this.editDialog = false
            if (this.$refs.editRemarkForm.validate()) {
                this.editRemark({text: this.selectedRemarkText}).then(response => {
                    this.getRemarks()

                }).catch(reason => {
                    //Stay here..
                    this.getRemarks()
                })
            }
        },
        doDeleteRemark() {
            this.deleteDialog = false
            this.deleteRemark(this.selectedRemark.id).then(response => {
                    this.getRemarks()

                }).catch(reason => {
                    //Stay here..
                    this.getRemarks()
                })
        },
        createNewRemark() {
            this.dialog = false
            if (this.$refs.newRemarkForm.validate()) {
                this.createRemark({
                    text: this.text,
                }).then(response => {
                    this.getRemarks()

                }).catch(reason => {
                    //Stay here..
                    this.getRemarks()
                })
            }
        },
        getText(key) {
            return getTranslationString(key)
        }
    }
}
</script>

